import React from 'react';
import classnames from 'classnames';
import './styles/audi-components.scss';

const icons = {
    "facebook": (<svg width="36px" height="36px" className="one-footer__social-media-icon"><path d="M15.768 15.737H12v3.315h3.768V29h4.422v-9.948h4.42v-3.315h-4.42v-1.335c0-1.002 1.053-3.087 2.589-3.087h1.831V8h-3.868c-5.457.795-4.974 7.737-4.974 7.737z" fill="currentColor"></path></svg>),
    "youtube": (<svg width="36px" height="36px" className="one-footer__social-media-icon"><path d="M28.79 13.58s-.206-1.448-.834-2.085c-.8-.837-1.695-.84-2.104-.89-2.94-.213-7.348-.213-7.348-.213h-.009s-4.408 0-7.347.213c-.41.05-1.304.053-2.104.89-.63.637-.834 2.085-.834 2.085S8 15.276 8 16.976v1.595c0 1.698.21 3.397.21 3.397s.205 1.447.834 2.085c.8.837 1.848.81 2.316.897 1.68.162 7.14.212 7.14.212s4.413-.006 7.35-.22c.412-.049 1.306-.053 2.106-.889.63-.637.834-2.085.834-2.085s.21-1.7.21-3.399v-1.593a31.8 31.8 0 00-.21-3.398zm-12.457 6.922l-.002-5.901 5.675 2.961-5.674 2.94z" fill="currentColor"></path></svg>),
    "instagram": (<svg width="36px" height="36px" className="one-footer__social-media-icon"><g fill="currentColor"><path d="M18 10.621c2.403 0 2.688.01 3.637.053.877.04 1.354.188 1.671.31.42.162.72.359 1.035.672.316.316.51.615.672 1.035.123.318.27.795.311 1.673.043.948.052 1.233.052 3.636s-.009 2.688-.052 3.637c-.04.878-.186 1.354-.31 1.671a2.8 2.8 0 01-.674 1.035c-.315.316-.615.51-1.035.672-.315.125-.792.27-1.67.311-.949.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.186-1.671-.31a2.787 2.787 0 01-1.036-.672 2.771 2.771 0 01-.671-1.036c-.125-.317-.27-.794-.311-1.67-.043-.95-.053-1.235-.053-3.638 0-2.403.01-2.688.053-3.637.04-.877.188-1.354.31-1.671.162-.42.359-.72.672-1.036.316-.315.615-.51 1.035-.671.318-.125.795-.27 1.673-.311.948-.043 1.233-.053 3.636-.053zM18 9c-2.445 0-2.751.01-3.711.054-.957.045-1.612.195-2.184.418a4.385 4.385 0 00-1.595 1.039 4.417 4.417 0 00-1.037 1.594c-.223.572-.376 1.227-.419 2.184C9.009 15.249 9 15.557 9 18c0 2.444.01 2.751.054 3.711.045.957.195 1.613.418 2.184.23.593.537 1.095 1.039 1.595a4.398 4.398 0 001.594 1.038c.572.222 1.227.375 2.184.418.96.045 1.268.054 3.711.054 2.444 0 2.751-.01 3.711-.054.957-.045 1.613-.195 2.184-.419a4.385 4.385 0 001.595-1.038 4.398 4.398 0 001.038-1.594c.222-.572.375-1.227.418-2.184.045-.96.054-1.267.054-3.711s-.01-2.751-.054-3.711c-.045-.957-.195-1.612-.419-2.184a4.412 4.412 0 00-1.038-1.595 4.41 4.41 0 00-1.594-1.037c-.572-.223-1.227-.376-2.184-.419C20.751 9.009 20.444 9 18 9z"></path><path d="M18 13.379a4.622 4.622 0 100 9.243 4.622 4.622 0 000-9.243zM18 21a3 3 0 110-6 3 3 0 010 6z"></path><circle cx="22.805" cy="13.195" r="1.08"></circle></g></svg>),
    "wechat": (<svg width="36px" height="36px" className="one-footer__social-media-icon"><g fill="currentColor" fillRule="evenodd"><path d="M17.57 14.306c.647.052 1.183-.511 1.184-1.162.001-.619-.551-1.16-1.183-1.16-.654 0-1.17.527-1.166 1.195.003.587.54 1.194 1.166 1.127m-7.198-1.15c.002.659.542 1.19 1.226 1.17a1.168 1.168 0 001.127-1.19c.003-.616-.563-1.17-1.205-1.146-.593.022-1.155.488-1.148 1.165m4.204-5.123c1.025.01 2.032.134 3.018.428a10.02 10.02 0 012.42 1.083 8.502 8.502 0 012.163 1.926c.44.546.761 1.158 1.024 1.803.128.315.216.64.277.974.021.117-.023.16-.131.156-.437-.017-.871.013-1.306.037-.362.021-.716.1-1.069.168-.51.1-1.011.246-1.493.45a9.39 9.39 0 00-1.604.834c-.775.52-1.45 1.142-1.985 1.907-.466.667-.808 1.392-.97 2.193-.094.458-.162.918-.142 1.388.021.495.108.977.245 1.453.069.238.054.247-.194.255a10.404 10.404 0 01-3.2-.4.944.944 0 00-.75.099c-.524.293-1.04.598-1.56.897-.137.08-.28.152-.418.23-.133.075-.265.085-.389-.01-.125-.096-.136-.225-.103-.373.114-.506.26-1.003.402-1.502.119-.42.062-.58-.29-.845a8.415 8.415 0 01-1.695-1.692 6.96 6.96 0 01-1.022-1.983c-.368-1.112-.385-2.238-.15-3.37.179-.856.56-1.628 1.056-2.345A7.463 7.463 0 018.063 10.3a9.264 9.264 0 011.904-1.238 10.23 10.23 0 013.4-.966 9.477 9.477 0 011.21-.064"></path><path d="M19.568 19.5c-.003.604.408 1.044.98 1.048.49.003.942-.487.938-1.018-.005-.558-.43-1.011-.952-1.016-.542-.005-.962.424-.966.986m5.927-.986c-.452-.044-.953.423-.96 1-.01.628.553 1.036.905 1.034.579-.004 1.03-.429 1.023-.99-.008-.572-.38-1.046-.968-1.044m-2.584-3.482c1.119.004 2.093.166 3.034.524a7.702 7.702 0 012.32 1.37c.417.36.8.76 1.116 1.219.686.994 1.085 2.099 1.115 3.346.037 1.576-.508 2.91-1.48 4.073a6.406 6.406 0 01-1.007.981c-.295.227-.34.477-.22.87.121.4.21.814.31 1.222.028.115.013.225-.085.3a.258.258 0 01-.312.02l-.947-.573c-.237-.144-.474-.29-.713-.432a.713.713 0 00-.595-.079c-.999.31-2.02.39-3.053.33a8.048 8.048 0 01-2.521-.576 7.775 7.775 0 01-2.101-1.274 6.423 6.423 0 01-1.5-1.832 5.784 5.784 0 01-.752-3.109c.047-1.197.434-2.268 1.1-3.233a6.859 6.859 0 011.277-1.382 7.461 7.461 0 012.308-1.287 7.71 7.71 0 011.487-.38c.443-.063.89-.112 1.219-.098"></path></g></svg>)
};

class Category extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: "false"
        };
    }

    render() {
        const {link, subLinks} = this.props;
        const {open} = this.state;
        return (
            <li className="one-footer__categories-list-item">
                <div className="one-footer__categories-link-wrapper" data-submenu-open={open} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({open: open === "true" ? "false" : "true"}); }}>
                    <a className="audi-link-l audi-link--inverted one-footer__categories-link" href={link.url}>
                        <span>{link.text}</span>
                        <svg className="one-footer__categories-arrow" height="24" width="24"><path d="M7 10l5.5 5.5L18 10" fill="none" stroke="currentColor"></path></svg>
                    </a>
                </div>
                <div className="one-footer__links">
                    <ul className="one-footer__links-list">
                        {subLinks && subLinks.map((link, n) => {
                            return (
                                <li className={classnames("one-footer__links-item", {"one-footer__links-item--overview": link.isOverview})} key={`cat-sub-${n}`}>
                                    <a className={classnames("one-footer__links-link audi-link-s", {"one-footer__links-link--overview": link.isOverview})} href={link.url} target={link.target ? link.target : "_self"}>
                                        {link.text}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </li>
        );
    }
}

class AudiFooter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null
        };
    }

    componentDidMount() {
        var url = `${this.props.api}/api/v1/myaudi/content/audiFooterLinks`;
        fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
          },
        }).then(
            (response) => {
                let ok = response.status >= 200 && response.status < 300;
                if (ok) {
                    response.json().then(data => {
                        this.setState({data: data});
                    }).catch(() => {
                        //
                    });
                } else {
                    //
                }
            }
        );
    }

    scrollToTop = (e) => {
        e.preventDefault();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        return false;
    }

    render() {
        const {data} = this.state;
        return (
            <div className="one-footer">
                <div className="one-footer__inner-wrapper">

                    <div className="one-footer__toolbar">
                        <a className="one-footer__to-top-link audi-link-s audi-link-s--arrow" href="#" onClick={this.scrollToTop}>
                            <span className="audi-link-s__text">{data && data.toTopLabel}</span>
                            <svg className="audi-link-s__icon" height="24" width="24" viewBox="0 0 24 24">
                                <path d="M7 10l5.5 5.5L18 10" fill="none" stroke="currentColor"></path>
                            </svg>
                        </a>
                    </div>

                    <div className="one-footer__categories">
                        <ul className="one-footer__categories-list">
                            {data && data.categories && data.categories.map((cat, i) => {
                                return (
                                    <Category link={cat.link} subLinks={cat.subLinks} key={`cat-${i}`} />
                                );
                            })}
                        </ul>
                    </div>

                    <div className="one-footer__social-media">
                        <ul className="one-footer__social-media-list">
                            {data && data.socialMedia && data.socialMedia.map((s, i) => {
                                if (s.id && s.link) {
                                    return (
                                        <li className="one-footer__social-media-item" key={`social-${s.id}`}>
                                            <a className="one-footer__social-media-link" href={s.link.url} target={s.link.target}>
                                                {icons[s.id]}
                                                <span className="one-footer__social-media-label">{s.link.text}</span>
                                            </a>
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </ul>
                    </div>

                    <div className="one-footer__toolbar one-footer__toolbar--border-top">
                        <div className="audi-copy-s one-footer__copyright">&copy; {new Date().getFullYear()} AUDI AG. All rights reserved</div>
                        <div className="one-footer__legal-links">
                            <ul className="one-footer__legal-links-list">
                                {data && data.legalLinks && data.legalLinks.map((link, i) => {
                                    let href = link.url;
                                    if (href.indexOf("http") !== 0) {
                                        href = "https://www.audi.com.au" + href;
                                    }
                                    return (
                                        <li className="one-footer__legal-item" key={`legal-${i}`}>
                                            <a className="one-footer__legal-link audi-link-s audi-link--inverted nm-layerLink" href={href}>{link.text}</a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

AudiFooter.defaultProps = {
    api: "https://cms.audidevelopment.com.au"
};

export default AudiFooter;
